import { forwardRef, type Ref, type SVGProps } from "react";
const IconLinkBrokenFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M19.81 16.89a6 6 0 0 1-4.8-2.4 2 2 0 1 1 3.2-2.4 2 2 0 0 0 2.79.4l3.88-2.91a1.94 1.94 0 0 0 .77-1.31 2 2 0 0 0-3.09-1.92l-1.2 1.11a2 2 0 1 1-2.72-2.92l1.45-1.34a6 6 0 0 1 7.19 9.59l-3.88 2.9a5.94 5.94 0 0 1-3.59 1.2M8 30a6 6 0 0 1-4.87-9.46l1.27-1.73a2 2 0 1 1 3.2 2.38l-1.26 1.7a2 2 0 0 0 3.28 2.27l2.8-3.95a2 2 0 0 0 .34-1.48 2 2 0 0 0-.76-1.29 2 2 0 0 1 2.32-3.26 6 6 0 0 1 1.41 8.35l-2.8 3.95A6 6 0 0 1 9 29.92 7 7 0 0 1 8 30m3.1-16.94a2 2 0 0 1-1.4-.57L6.59 9.42a2 2 0 0 1 2.82-2.84l3.1 3.06a2 2 0 0 1 0 2.83 2 2 0 0 1-1.41.59"
    />
    <path
      fill="currentColor"
      d="M8.22 17.1a2.2 2.2 0 0 1-.51-.1L3.5 15.94a2 2 0 1 1 1-3.88l4.22 1.11a2 2 0 0 1-.5 3.93M15 10.21a2 2 0 0 1-1.93-1.48l-1.15-4.2a2 2 0 1 1 3.85-1.06l1.16 4.2A2 2 0 0 1 15 10.21"
    />
  </svg>
);
const ForwardRef = forwardRef(IconLinkBrokenFilledSVG);
ForwardRef.displayName = "IconLinkBrokenFilled";
export { ForwardRef as IconLinkBrokenFilled };
